import { Stack } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useSubmit from "../../../master/species/hooks/useSubmit";
import DialogCore from "../core/DialogCore";
import BoxPetSelector from "./components/BoxPetSelector";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../../utils/Functions";
import { ADD_PET_TO_BOX } from "../../../../enums/ApiPaths";
import { formatToSimpleDate } from "../../../../utils/DateTimeRepository";
import { useQueryClient } from "@tanstack/react-query";
import { AVAILABLE_BOXES_KEY } from "../../../../enums/QueryKeys";
const formId = "add-pet-to-box-id";

export function formatPet(pet = null, data = null) {
  if (!pet || !data) {
    return;
  }
  return {
    id: pet.id,
    birthdate: formatToSimpleDate(pet?.birthdate),
    description: pet?.description,
    aggression: pet?.aggression,
    gender: pet?.gender ?? "MALE",
    name: pet?.name,
    type: pet?.type,
    microchip: data?.microchip,
    passport: data?.passport,
    user: data?.user,
    bloodDonor: data?.blood_donor,
    bloodType: data?.blood_type,
    breed: pet?.breed,
  };
}

export default function AddPetToBox({ isIcon = true }) {
  const methods = useForm();
  const { id } = useParams();
  const url = ADD_PET_TO_BOX + id;
  const isMobile = useIsMobile();
  const submittion = useSubmit(null, url);
  const queryClient = useQueryClient();
  async function submitData(data) {
    const pet = data?.pet ? data?.pet : null;

    if (pet) {
      const formattedPet = formatPet(pet, data);
      var submitData = {
        pet: formattedPet,
      };
      if (data.user) {
        submitData = {
          ...submitData,
          userData: data.user.userDetails,
        };
      }
      const success = await submittion.submitCallback(submitData);

      if (success) {
        queryClient.invalidateQueries([AVAILABLE_BOXES_KEY]);
        methods.reset();
      }
    }
  }

  const { t } = useTranslation();
  return (
    <FormProvider {...methods}>
      <form id={formId} onSubmit={methods.handleSubmit(submitData)}>
        <DialogCore
          formId={formId} //This is needed for the submit button to work
          buttonSize="small"
          isIcon={isMobile}
          buttonTitle={t("AddPet")}
          maxWidth="md"
          title={"Add a new pet to the box"}
          isLoading={submittion.loading}
          closeWhen={submittion.success}
        >
          <Stack spacing={2}>
            <BoxPetSelector
              key={"add-pet-to-box-pet-selector"}
              showUserSelector={true}
            />
          </Stack>
        </DialogCore>
      </form>
    </FormProvider>
  );
}
